import React, { useCallback, useContext, useEffect } from 'react';
import Cover from '../../../layout/Cover';
import Steps from './StepsController/Steps';
import CreateASpoolContext from '../../../context/createASpool/createASpoolContext';
import StepButtons from './StepsController/StepButtons';
import { TabsContext } from '../../../components/Tabs';
import { StepButtonArrowLongIcon } from '../../../assets/icons';
import { useWeb3React } from '@web3-react/core';

const CreateASpool: React.FC = () => {
    const { updateHeight } = useContext(TabsContext);

    const { account, chainId } = useWeb3React();

    const {
        steps,
        currentStep,
        selectedAsset,
        selectedRiskModel,
        spoolFee,
        spoolName,
        allocations,
        riskTolerance,
        back,
        next,
        setCurrentStep,
        createSpool,
        validateSpoolName,
        setStepCompletedStatus,
        setSelectedAsset,
        setSelectedRiskModel,
    } = useContext(CreateASpoolContext);

    const hasPrevious = currentStep > 1;
    const hasNext = currentStep < steps.length;

    useEffect(() => {
        setSelectedAsset(null);
        setSelectedRiskModel(null);
        setStepCompletedStatus(1, false);
        setCurrentStep(1);
    }, [
        chainId,
        setCurrentStep,
        setStepCompletedStatus,
        setSelectedAsset,
        setSelectedRiskModel,
    ]);

    useEffect(() => {
        window.scrollTo(0, 0);

        updateHeight();
    }, [currentStep, updateHeight]);

    const handleCreate = useCallback(() => {
        if (!account || !selectedAsset || !selectedRiskModel || !allocations) return;

        if (!validateSpoolName(spoolName)) return;

        createSpool({
            creator: account,
            name: spoolName,
            vaultFee: spoolFee * 100,
            underlying: selectedAsset,
            riskTolerance,
            riskProvider: selectedRiskModel,
            strategies: Object.keys(allocations),
            proportions: Object.values(allocations),
        });
    }, [
        account,
        selectedAsset,
        selectedRiskModel,
        spoolName,
        spoolFee,
        riskTolerance,
        allocations,
        createSpool,
        validateSpoolName,
    ]);

    return (
        <div className='app-tab create'>
            <Cover useMinHeight={true}>
                <div className='inner__left'>
                    <h2>Create a Spool</h2>
                    <div className='buttons-container'>
                        <div onClick={back} className={!hasPrevious ? 'disabled' : ''}>
                            <StepButtonArrowLongIcon />
                            <span>Back</span>
                        </div>
                        {!hasNext && hasPrevious ? (
                            <div
                                onClick={handleCreate}
                                className={
                                    !steps[currentStep - 1].completed ? 'disabled' : ''
                                }
                            >
                                <span>Create</span>
                                <StepButtonArrowLongIcon />
                            </div>
                        ) : (
                            <div
                                onClick={next}
                                className={
                                    !hasNext || !steps[currentStep - 1].completed
                                        ? 'disabled'
                                        : ''
                                }
                            >
                                <span>Next</span>
                                <StepButtonArrowLongIcon />
                            </div>
                        )}
                    </div>
                </div>
                <div className='inner__right'>
                    <Steps />
                    {steps[currentStep - 1].render}
                    <StepButtons />
                </div>
            </Cover>
        </div>
    );
};

export default CreateASpool;
